import MoreVertIcon from "@mui/icons-material/MoreVert";
import { Button, Dialog, IconButton, Modal, Popover, Tooltip } from "@mui/material";
import { truncateText } from "components/helper";
import WholeScreenLoader from "components/WholeScreenLoader";
import { MaterialReactTable, useMaterialReactTable } from "material-react-table";
import { useMemo, useState } from "react";
import { AiFillDelete, AiFillEdit } from "react-icons/ai";
import { toast } from "react-toastify";
const PreivewModal = ({ data, isFetching, open, handleClose, fetchSelectedRPLCourses }) => {
  const handleImportSelectedData = () => {
    const selectedData = table.getSelectedRowModel().flatRows.map((row) => {
      return row.original;
    });
    fetchSelectedRPLCourses(selectedData);
  };

  const columns = useMemo(
    () => [
      {
        accessorKey: "courseName",
        header: "Course Name",
        size: 150,
      },
      {
        accessorKey: "courseCode",
        header: "Course Code",
        size: 150,
        Cell: ({ renderedCellValue }) => {
          return (
            <Tooltip title={renderedCellValue} arrow placement="top">
              <div className="truncate">{renderedCellValue ?? "-"}</div>
            </Tooltip>
          );
        },
      },
      {
        accessorKey: "collegeName",
        header: "College Name",
        size: 150,
      },
      {
        accessorKey: "rtoCode",
        header: "RTO Code",
        size: 150,
      },
      {
        accessorKey: "minCost",
        header: "Minimum Cost",
        size: 150,
      },
      {
        accessorKey: "maxCost",
        header: "Maximum Cost",
        size: 150,
      },
      {
        accessorKey: "sellCost",
        header: "Selling Cost",
        size: 150,
      },
      {
        accessorKey: "requirements",
        header: "Requirements",
        size: 150,
        maxSize: 150,
        Cell: ({ renderedCellValue }) => {
          return (
            <Tooltip title={renderedCellValue} arrow placement="top">
              <div className="truncate">{truncateText(renderedCellValue, 40)}</div>
            </Tooltip>
          );
        },
      },
      {
        accessorKey: "note",
        header: "Note",
        size: 150,
        Cell: ({ renderedCellValue }) => {
          return (
            <Tooltip title={renderedCellValue} arrow placement="top">
              <div className="truncate">{truncateText(renderedCellValue, 40)}</div>
            </Tooltip>
          );
        },
      },
    ],
    []
  );

  const table = useMaterialReactTable({
    columns,
    data: data || [],
    rowNumberDisplayMode: "original",
    enableRowNumbers: true,
    initialState: {
      enableGlobalFilter: true,
      showGlobalFilter: true,
      density: "compact",
    },
    enablePagination: false,
    enableRowSelection: true,
    enableStickyHeader: true,
    enableColumnPinning: true,
    muiSkeletonProps: {
      animation: "wave",
    },
    muiLinearProgressProps: {
      color: "secondary",
    },
    muiCircularProgressProps: {
      color: "secondary",
    },

    muiTableContainerProps: {
      sx: {
        maxHeight: "70vh",
        minHeight: "70vh", // Set max height
        overflowY: "auto", // Enable vertical scrolling
      },
    },
    muiTableBodyRowProps: ({ row }) => ({
      sx: {
        cursor: "pointer",
        "&:hover": {
          backgroundColor: "rgba(0, 0, 0, 0.04)",
        },
      },
    }),
  });

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="lg" fullWidth>
      <div className="flex flex-wrap mt-4 dashBody">
        <div className="w-full mb-12 px-4">
          <div className="flex items-center justify-between">
            <h3 className="text-2xl font-bold">Preview Data ({data?.length})</h3>
          </div>
          <div className="block w-full overflow-x-auto">
            {isFetching && <WholeScreenLoader open={isFetching} />}
            <MaterialReactTable table={table} />
          </div>
          <div className="flex justify-end mt-4 gap-4">
            <Button variant="contained" color="primary" onClick={handleClose}>
              Close
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={handleImportSelectedData}
              disabled={!table.getSelectedRowModel().rows.length > 0}
            >
              Import Selected Data
            </Button>
          </div>
        </div>
      </div>
    </Dialog>
  );
};

export default PreivewModal;
